import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';

var InlineAlertIconName;
(function (InlineAlertIconName) {
    InlineAlertIconName["critical"] = "alert__critical";
    InlineAlertIconName["info"] = "alert__info";
    InlineAlertIconName["success"] = "status__confirm";
    InlineAlertIconName["warning"] = "alert__warning--full-color";
})(InlineAlertIconName || (InlineAlertIconName = {}));
var InlineAlertVariant;
(function (InlineAlertVariant) {
    InlineAlertVariant["critical"] = "critical";
    InlineAlertVariant["info"] = "info";
    InlineAlertVariant["success"] = "success";
    InlineAlertVariant["warning"] = "warning";
})(InlineAlertVariant || (InlineAlertVariant = {}));
const A11Y_ICON_TEXT_MAPPING = {
    critical: 'Error!',
    info: 'Information',
    success: 'Success',
    warning: 'Warning',
};
const DEFAULT_VARIANT = InlineAlertVariant.critical;
const DEFAULT_SIZE = StandardSize.medium;
const DEFAULT_ENABLE_A11Y_ATTRIBUTES = false;
/**
 * Providence Inline Alert component.
 * @see {@link https://providence.fmr.com/4.x/components/inline-alert/inline-alert.html|Inline Alert documentation}
 */
class PvdInlineAlert extends ScopedElementsMixin(PvdSlotifyBaseComponent) {
    constructor() {
        super(...arguments);
        this.pvdEnableA11yAttributes = DEFAULT_ENABLE_A11Y_ATTRIBUTES;
        this.pvdSize = DEFAULT_SIZE;
        this.pvdVariant = DEFAULT_VARIANT;
        // #endregion
    }
    static get scopedElements() {
        // $namespace-$name-$extendingComponentName
        return {
            'pvd-scoped-icon': customElements.get(`${this.namespace}-icon`),
        };
    }
    // #endregion
    // #region private methods
    get iconName() {
        return InlineAlertIconName[this.pvdVariant.toLowerCase()];
    }
    get roleAttribute() {
        if (this.pvdEnableA11yAttributes) {
            return this.pvdVariant === InlineAlertVariant.critical ? 'alert' : 'status';
        }
    }
    get ariaLiveAttribute() {
        if (this.pvdEnableA11yAttributes) {
            return this.pvdVariant === InlineAlertVariant.critical ? 'assertive' : 'polite';
        }
    }
    get iconSize() {
        return this.pvdSize === StandardSize.large ? Size.medium : Size.small;
    }
    // #endregion
    ////////////
    // RENDER //
    ////////////
    // #region LitElement lifecycles
    renderAlertIcon() {
        return this.scopeTemplate `
      <pvd-scoped-icon
        pvd-name="${this.iconName}"
        pvd-size="${this.iconSize}"
        pvd-a11y-label="${this.pvdA11yIconText || A11Y_ICON_TEXT_MAPPING[this.pvdVariant]}"
      ></pvd-scoped-icon>
    `;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-inline-alert-root`,
            modifierPrefix: 'pvd-inline-alert',
            modifiers: [
                {
                    condition: true,
                    className: `${this.pvdSize}`,
                },
                {
                    condition: true,
                    className: this.pvdVariant,
                },
            ],
        };
        return x `<div id="${l(this.pvdId)}" class="${getClassName(classMap)}" role="${l(this.roleAttribute)}" aria-live="${l(this.ariaLiveAttribute)}"><div class="pvd-inline-alert__icon">${this.renderAlertIcon()}</div><div class="pvd-inline-alert__content">${this.pvdTitle
            ? x `<strong class="pvd-alert-content__title">${this.pvdTitle}</strong>`
            : ''}<s-slot>${this.pvdText}</s-slot></div></div>`;
    }
}
//#region Component configuration
PvdInlineAlert.componentName = 'inline-alert';
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-a11y-icon-text',
    }),
    __metadata("design:type", String)
], PvdInlineAlert.prototype, "pvdA11yIconText", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-enable-a11y-attributes',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-enable-a11y-attributes'),
    }),
    __metadata("design:type", Boolean)
], PvdInlineAlert.prototype, "pvdEnableA11yAttributes", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-id' }),
    __metadata("design:type", String)
], PvdInlineAlert.prototype, "pvdId", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-size',
        ...PvdSlotifyBaseComponent.hasChanged(StandardSize),
    }),
    __metadata("design:type", Number)
], PvdInlineAlert.prototype, "pvdSize", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-text' }),
    __metadata("design:type", String)
], PvdInlineAlert.prototype, "pvdText", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-title' }),
    __metadata("design:type", String)
], PvdInlineAlert.prototype, "pvdTitle", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-variant',
        ...PvdSlotifyBaseComponent.hasChanged(InlineAlertVariant),
    }),
    __metadata("design:type", String)
], PvdInlineAlert.prototype, "pvdVariant", void 0);

export { DEFAULT_ENABLE_A11Y_ATTRIBUTES, DEFAULT_SIZE, DEFAULT_VARIANT, InlineAlertIconName, InlineAlertVariant, PvdInlineAlert };
//# sourceMappingURL=pvd-inline-alert.js.map
